/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ReactPlayer from 'react-player';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';

import OnAirItem from '../../components/OnAirItem';

import ReactHoverObserver from 'react-hover-observer';

class UpdateContent extends Component {
  state = {
    mouseOn: false,
    mute: true,
    buttonIndex: 0,
  };
  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;
    this._getWindowSize();
    window.addEventListener('resize', this._getWindowSize);
    this._getContent();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
    window.removeEventListener('resize', this._getWindowSize);
  };
  _getWindowSize = () => {
    //console.log(window.innerWidth)
    const hSize = (window.innerWidth - 18) * (1080 / 1920);
    this.setState({
      wSize: window.innerWidth - 18,
      hSize: hSize,
    });
  };
  _getContent = async () => {
    // const { loginId } = this.props;

    const result = await this._getContentApi();
    const intReturn = result.data[0].intReturn;
    const onAirList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          onAirList,
        });
      }
    }
  };
  _getContentApi = () => {
    const { apiUrl } = this.props;

    return axios(apiUrl + '/onAir')
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };

  _renderItem = () => {
    const { onAirList } = this.state;
    //console.log(wSize)

    const list = onAirList.map((item, index) => {
      return (
        <OnAirItem
          key={index}
          index={index}
          title={item.title}
          subTitle={item.subTitle}
          outputStart={item.outputStart}
          outputEnd={item.outputEnd}
          ratio={item.ratio}
        />
      );
    });

    return list;
  };
  _onToggleMouseOn = () => {
    //const { mouseOn } = this.state;

    this.setState({
      mouseOn: true,
    });
  };
  _onToggleMouseOff = () => {
    //const { mouseOn } = this.state;

    this.setState({
      mouseOn: false,
    });
  };
  _toggleMute = () => {
    const { mute } = this.state;

    this.setState({
      mute: !mute,
    });
  };
  _onLiveTimeline = () => {
    const { setTimeline } = this.props;
    setTimeline(true);
  };
  _goLive = () => {
    const { history } = this.props;

    history.push('/live');
  };
  _goItem = () => {
    const { setContentSerial } = this.props;
    const { onAirList } = this.state;
    this.setState({
      buttonIndex: 1,
    });
    setContentSerial(onAirList[0].contentSerial);
  };
  render() {
    const { onAirList, mouseOn, buttonIndex } = this.state;
    const { imgUrl } = this.props;
    // const { tveeImgUrl } = this.props;
    return (
      <Fragment>
        {onAirList ? (
          <div className="main_list_style">
            <h1>
              <strong>LIVE ON AIR!</strong>
              <div>
                <a style={{ cursor: 'pointer' }} onClick={this._onLiveTimeline}>
                  LIVE 편성표
                </a>
              </div>
            </h1>
            <div className="main_list_goup4">
              <dl>
                <dt>
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={this._toggleMute}
                  >
                    <img src={imgUrl + '/img/sound.png'} />
                  </span>

                  <ReactHoverObserver
                    hoverDelayInMs={500}
                    hoverOffDelayInMs={300}
                  >
                    {({ isHovering }) => (
                      <div>
                        {onAirList[0].imageLO === '' ||
                        onAirList[0].imageLO === null ||
                        onAirList[0].imageLO === undefined ? (
                          <img src={imgUrl + '/img/temp/noimg_w.png'} />
                        ) : isHovering ? (
                          <div>
                            <ReactPlayer
                              url={
                                'https://jjmp4.ofscdn.com' +
                                onAirList[0].opening
                              }
                              //className='bg_img'
                              playing={true}
                              //url={playUrl}
                              volume={0.5}
                              muted={true}
                              //onReady={this._onReady}
                              //onEnded={this._onEnded}
                              //style={{width: wSize, height: hSize}}
                              width={789}
                              height={442}
                            />
                          </div>
                        ) : (
                          <img
                            src={onAirList[0].thumbImg}
                            style={{ width: 789, height: 442 }}
                          />
                        )}
                      </div>
                    )}
                  </ReactHoverObserver>
                </dt>
                <dd>
                  <div className="text_group">
                    {onAirList ? (
                      onAirList[0].imageLO === '' ||
                      onAirList[0].imageLO === null ||
                      onAirList[0].imageLO === undefined ? (
                        <h2>{onAirList[0].title}</h2>
                      ) : (
                        <img src={onAirList[0].imageLO} className="img_logo" />
                      )
                    ) : null}
                    <h2>
                      {onAirList[0].subTitle}
                      <em>{onAirList[0].restrictionCode}</em>
                    </h2>
                    {onAirList[0].contentEpisode === '' ||
                    onAirList[0].contentEpisode === undefined ||
                    onAirList[0].contentEpisode == null ? null : (
                      <HTMLEllipsis
                        unsafeHTML={`<p>${onAirList[0].contentEpisode.replace(
                          /<[^>]+>/g,
                          ''
                        )}</p>`}
                        maxLine="3"
                        ellipsis="..."
                        basedOn="letters"
                      />
                    )}

                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={this._goLive}
                      className={buttonIndex === 0 ? 'on' : null}
                    >
                      <img src={imgUrl + '/img/play4.png'} />
                      지금 감상하기
                    </a>
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={this._goItem}
                      className={buttonIndex === 1 ? 'on' : null}
                    >
                      <img src={imgUrl + '/img/info.png'} />
                      작품 상세보기
                    </a>
                  </div>
                  <div
                    className="time_group"
                    onMouseEnter={this._onToggleMouseOn}
                    onMouseLeave={this._onToggleMouseOff}
                  >
                    <ScrollMenu
                      data={onAirList ? this._renderItem() : null}
                      arrowLeft={
                        mouseOn ? (
                          <a
                            className="time_left_btn"
                            style={{ cursor: 'pointer' }}
                            onClick={this._arrowPrev}
                          >
                            <span className={'on'}>이전</span>
                          </a>
                        ) : null
                      }
                      arrowRight={
                        mouseOn ? (
                          <a
                            className="time_right_btn"
                            style={{ cursor: 'pointer' }}
                            onClick={this._arrowNext}
                          >
                            <span className={'on'}>다음</span>
                          </a>
                        ) : null
                      }
                      wheel={false}
                      dragging={true}
                      transition={0.5}
                      translate={1}
                      alignOnResize={true}
                      //inertiaScrolling={true}
                      inertiaScrollingSlowdown={1}
                      //wrapperStyle={{border: 0, backgroundColor: '#000'}}
                      alignCenter={false}
                      hideSingleArrow={true}
                      hideArrows={mouseOn}
                    />
                    {/*
                                        <div className="time_div">
                                            <div className="time_text">
                                                <em className="on_text">21:00</em>
                                                <p className="on_text"><img src="img/on.png"/>오호츠키의 냉청<span className="on_text">15화. 마녀란 무엇인가 / 양장도락</span></p>
                                                <strong>22:30</strong>
                                            </div>
                                            <div style={{backgroundColor: '#af0000', width: '50%', position: 'absolute', height: '100%', top: 0}}></div>
                                        </div>
                                        <div className="time_div">
                                            <div className="time_text">
                                                <em>21:00</em>
                                                <p><img src="img/yeyag.png"/>오호츠키의 냉청<span>15화. 마녀란 무엇인가 / 양장도락</span></p>
                                                <strong>22:30</strong>
                                            </div>
                                        </div>

                                        <a href="#" className="time_left_btn"><span>이전</span></a>
                                        <a href="#" className="time_right_btn"><span className="on">다음</span></a>
                                    */}
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(UpdateContent));
